
import React, { Component}  from 'react';
import { FormProvider, FormContext } from 'core/FormProvider';
import { UserContext } from 'components/User';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { TariffIndividualForm } from './FormIndividual';


export default class TariffAddIndividual extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новый индивидуальный тариф';
  }

  onDetail = (item) => {
    this.props.history.push(`/tariff`);
  };

  render() {
    return (
      <FormProvider
        url={'tariff'}
        postSave={(item) => this.onDetail(item)}
        item={{
          department: this.context.data.department_active,
          resourcetype: 'TariffIndividual',
          is_active: true,
          tariff_points: [],
          services: []
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading, item } = context;
          return (
            <Layout>
              <Layout.Header
                title={'Создание индивидульного тарифа'}
                backUrl={'/tariff'}
              />

              <Layout.ContentSimple>

                <TariffIndividualForm item={item} />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                  >
                    Создать индивидульный тариф
                  </YellowButton>
                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
